import { render, staticRenderFns } from "./TimedAlert.vue?vue&type=template&id=143190c2"
import script from "./TimedAlert.vue?vue&type=script&lang=ts"
export * from "./TimedAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports